var map = {
	"./counterstatistics/router.ts": "d719",
	"./foreignexchangecollection/router.ts": "13cb",
	"./reportstatistics/router.ts": "f3ea",
	"./shared/error-page/components/router.ts": "fbbd",
	"./shared/login/router.ts": "6356",
	"./shared/main/router.ts": "2ac0",
	"./shipment/router.ts": "a42f",
	"./system/router.ts": "65e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c049";